import QuillEditor from "@components/CreateQuestion/Question/QuillEditor";
import React from "react";
import { Controller } from "react-hook-form";

const AdditionalNotes:React.FC<any> = ({ errors, control }) => {
  return (
    <div className="w-[80%] self-end">
      <div style={{ position: "relative" }} className="w-[80%] mt-5">
        <Controller
          name="additionalNotes"
          rules={{
            required: "This field is required.",
          }}
          control={control}
          render={({ field: { value, onChange } }) => (
            <QuillEditor
              label="Additional notes"
              required
              value={value}
              onChange={onChange}
            />
          )}
        />
        {errors["additionalNotes"]?.message && (
          <span className="whitespace-pre text-xs mt-2 text-orange-700">
            {errors["additionalNotes"]?.message}
          </span>
        )}
      </div>
    </div>
  );
};

export default AdditionalNotes;
